import { EnumCookiesAuth } from "@tiendeo/auth";
import { AxiosInstance, AxiosRequestConfig } from "axios";
import { IGamificationApiClientConfig } from "../gamificationApiClient";

export default class BaseController {
    constructor(
        protected httpClient: AxiosInstance,
        protected config: IGamificationApiClientConfig,
    ) {}

    protected async MakeRequest<T = any>(config: AxiosRequestConfig, headers = {}): Promise<T> {
        config.headers = {
            ...this.getHeaders(headers),
            ...config.headers,
        };
        const response = await this.httpClient.request<T>(config);

        return response.data;
    }

    private getHeaders(headers: object) {
        const token = this.config.getCookie(EnumCookiesAuth.ACCESS_TOKEN);

        if (!token) {
            return headers;
        }

        return {
            ...headers,
            Authorization: `Bearer ${token}`,
        };
    }
}
